import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { handleWebsocketMessage } from "../websocket";

import Header from './Header';
import NotificationsBar from './NotificationsBar';

import userActions from '../actions/userActionCreators';

import StompJsClient from 'react-stomp'
import env from '../environment'

class TashiDesktop extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.displayName = 'TashiDesktopWeb';
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        this.props.dispatch(userActions.loadCurrentUser());
    }

    // RENDER METHOD

    render = () => {
        return (
            <div>
                <Header user = {localStorage.getItem('user')}/>
                <NotificationsBar />
                <div className="container-fluid">
                    {this.props.children}
                </div>
                <StompJsClient url={env.tashi + '/ws'} topics={['/user/queue/tashi']} onMessage={(msg) => handleWebsocketMessage(msg)}/>
            </div>
        );
    }
}

TashiDesktop.propTypes = {
    children: PropTypes.element,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    error: PropTypes.object
};

const mapStateToProps = (state) => {
    if(state.users.currentUser)
        localStorage.setItem('user', JSON.stringify(state.users.currentUser));
    return {
        currentUser: state.users.currentUser,
        error: state.users.error
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TashiDesktop);



/** WEBPACK FOOTER **
 ** ./src/app/components/TashiDesktop.js
 **/